import { render, staticRenderFns } from "./editAssetModel.vue?vue&type=template&id=2d8aca74&scoped=true"
import script from "./editAssetModel.vue?vue&type=script&lang=js"
export * from "./editAssetModel.vue?vue&type=script&lang=js"
import style0 from "./editAssetModel.vue?vue&type=style&index=0&id=2d8aca74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8aca74",
  null
  
)

export default component.exports